module.exports = __webpack_public_path__ + "img/shopee.00dc9409.png";